import React from 'react';
import { ITableDataSource } from 'models/table';
import { colors } from 'theme/colors';
import Grid from '@mui/material/Grid';
import { Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Chips } from 'components/atoms/Chips';
import { emptyFieldHolder } from 'components/molecules/CardList';
import { batchStatusVariant } from 'pages/LicencesPage/helpers';

interface IBatchHistoryTableCard {
  data: ITableDataSource;
}

export const BatchHistoryTableCard = ({ data }: IBatchHistoryTableCard) => {
  const { t } = useTranslations();

  return (
    <Grid
      container
      sx={{
        border: `1px solid ${colors.gray200}`,
        borderRadius: '4px',
        overflow: 'hidden',
        mt: 1,
        p: 2,
        rowGap: 2,
        backgroundColor: colors.gray100,
      }}
    >
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.batchHistory.dateTime.column')}
        </Typography>
        <Typography variant="body2">{data.createdDate}</Typography>
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.batchStatus.label')}
        </Typography>
        <Chips text={data.status} variant={batchStatusVariant(data.statusUniqueId)} />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <Typography variant="subtitle2" sx={{ marginBottom: '4px' }}>
          {t('licences.batchHistory.description.column')}
        </Typography>
        <Typography variant="body2">{emptyFieldHolder(t(data.description))}</Typography>
      </Grid>
    </Grid>
  );
};
